import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { withOidcSecure } from '@axa-fr/react-oidc'
import NotificationConfigureTableItem from '../NotificationConfigure/NotificationConfigureTableItem';
import { useSelector } from 'react-redux';

const NotificationAccordion = ({ categories, notifications, updateConfigObjectByAlertCode, isReset }) => {
    const { t } = useTranslation();
    const [expandedCategories, setExpandedCategories] = useState({});
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);

    const toggleCategory = (categoryCode) => {
        setExpandedCategories(prev => ({
            ...prev,
            [categoryCode]: !prev[categoryCode]
        }));
    };


    const getNotificationsByCategory = (categoryCode) => {
        return notifications.filter(notification =>
            notification.NotificationCategoryCode === categoryCode
        );
    };


    const isCategoryExpanded = (categoryCode) => {
        return expandedCategories[categoryCode] || false;
    };

     const hasMandatoryNotifications = (categoryCode) => {
        const categoryNotifications = getNotificationsByCategory(categoryCode);
        return categoryNotifications.some(notification => notification.Category === "Mandatory");
    };



    return (
        <div className='flex flex-col my-5 gap-6'>
            {categories.map((category) => {
                const categoryNotifications = getNotificationsByCategory(category.Code);
                const isExpanded = isCategoryExpanded(category.Code);
               
                return (
                    <div key={category.Code} className='flex flex-col'>
                        {/* Category Header */}
                        <div
                            className='flex flex-row justify-between items-center w-full cursor-pointer py-4   transition-colors duration-200'
                            onClick={() => toggleCategory(category.Code)}
                        >
                            <div className='flex flex-col flex-1'>
                                <p className={`font-hanken-grotesk font-[600] text-[18px] leading-[24px] sm:font-[700] sm:text-[14px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[28px] ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                  {category.DisplayText}{hasMandatoryNotifications(category.Code) && <span className={`${kudzuPlusTrue ? "text-white-500" : "text-black-500"} ml-1`}>*</span>}
                                </p>
                              
                                
                            </div>
                            <div className='ml-4'>
                                <svg
                                    className={`w-5 h-5 text-[var(--notificationTextColor)] transition-transform duration-200 ${
                                        isExpanded ? 'rotate-0' : 'rotate-180'
                                    }`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>


                        
                         {/* Category Content */}
                        {isExpanded && (
                            <div className='flex flex-col gap-6  border-gray-200 '>
                                  <p className={`font-hanken-grotesk font-[600] text-[14px] leading-[20px] sm:font-[600] sm:text-[12px] sm:leading-[18px] md:font-[500] md:text-[14px] md:leading-[22px]  mb-4 mt-1 ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                    {category.Description}
                                </p>
                                     
                                { category.CategoryInfo && (
                                     <p className={`font-hanken-grotesk font-[300] text-[14px] leading-[20px] sm:font-[300] sm:text-[12px] sm:leading-[18px] md:font-[300] md:text-[14px] md:leading-[22px]  mb-8 mt-1 ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                         {category.CategoryInfo}
                                     </p>
                                 )}     

                                 {/* Notifications Header */}
                                 <div className='flex flex-row justify-between w-full mb-4'>
                                     <div className='w-[70%]'>
                                         <p className={`font-hanken-grotesk font-[500] text-[16px] leading-[24px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[28px] ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                             {t("notifications")}
                                         </p>
                                     </div>
                                     <div className={`flex flex-row justify-between items-center ${category.ShowPush ? "w-[30%]" : "w-[27%]"} `}>
                                         {category.ShowPush && (
                                             <div>
                                                 <p className={`font-hanken-grotesk font-[500] text-[16px] leading-[24px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[28px] ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                                     {t("Push")}
                                                 </p>
                                             </div>
                                         )}
                                         {category.ShowEmail && (
                                             <div>
                                                 <p className={`font-hanken-grotesk font-[500] text-[16px] leading-[24px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[28px] ml-6 ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                                     {t("email")}
                                                 </p>
                                             </div>
                                         )}
                                         {category.ShowSMS && (
                                             <div>
                                                 <p className={`font-hanken-grotesk font-[500] text-[16px] leading-[24px] sm:font-[700] sm:text-[12px] sm:leading-[20px] md:font-[600] md:text-[18px] md:leading-[28px] ${kudzuPlusTrue ? "text-[#ffffff]" : ""}`}>
                                                     {t("text")}
                                                 </p>
                                             </div>
                                         )}
                                     </div>
                                 </div>








                                 {/* Notifications List */}
                                 {categoryNotifications.map((notificationSettingItem) => (
                                     <NotificationConfigureTableItem
                                         key={notificationSettingItem.AlertCode}
                                         notificationSettingItem={notificationSettingItem}
                                         updateConfigObjectByAlertCode={updateConfigObjectByAlertCode}
                                         isReset={isReset}
                                         categoryShowFlags={{
                                             ShowPush: category.ShowPush,
                                             ShowEmail: category.ShowEmail,
                                             ShowSMS: category.ShowSMS
                                         }}
                                     />
                                 ))}

        
                            </div>
                            
                        )}
                         <hr className="h-[2px] bg-blue-sky border-0 rounded mt-6" />
                    </div>
                    
                    
                );
            })}
        </div>
    );
};


export default withOidcSecure(NotificationAccordion);



